import api from '@api';
import { all, call, put, takeEvery } from 'redux-saga/effects';
import {
    patchMultipleReturnsFetchFailure,
    patchMultipleReturnsFetchSuccess,
    patchReturnFetchFailure,
    patchReturnFetchSuccess,
    synchronizeReturnsDCIXFetchFailure,
    synchronizeReturnsDCIXFetchSuccess
} from './reducer';

import { getReturnsGridFetch } from '../returnsGrid/reducer'; // Importuj akci pro načítání gridu vratky
import translate from '@translate';
import { ReturnType } from 'src/types/return';

// Funkce pro API volání
const patchReturnFetchRequest = async (returnItem: ReturnType, data: ReturnType) => {
    const res = await api('patch', `api/secure/returns/${returnItem.ID}`, data);
    return res.data;
};

// Saga pro jedno API volání
function* patchReturnFetch(action: { type: string; payload: { returnItem: ReturnType; data: ReturnType } }) {
    const { returnItem, data } = action.payload;

    try {
        yield call(() => patchReturnFetchRequest(returnItem, data));
        yield put(patchReturnFetchSuccess());
    } catch (error) {
        yield put(patchReturnFetchFailure({ error }));
    }
}

// Watcher pro jednotlivé API volání
export function* patchReturnFetchWatch() {
    yield takeEvery('returnsUpdate/patchReturnFetch', patchReturnFetch);
}

// Saga pro zpracování více vratek
function* patchMultipleReturnsFetch(action: { type: string; payload: { returns: ReturnType[]; data: ReturnType } }) {
    const { returns, data } = action.payload;
    const batchSize = 10; // Nastav velikost stránky (počet vratek na jednu dávku)

    try {
        // Rozdělení returns na menší dávky
        for (let i = 0; i < returns.length; i += batchSize) {
            const chunk = returns.slice(i, i + batchSize);

            // Zpracování každé dávky samostatně
            yield all(
                chunk.map((returnItem) =>
                    call(patchReturnFetch, { type: 'returnsUpdate/patchReturnFetch', payload: { returnItem, data } })
                )
            );
        }

        yield put(patchMultipleReturnsFetchSuccess());
        yield put(getReturnsGridFetch(undefined)); // Načtení gridu vratek
    } catch (error) {
        yield put(patchMultipleReturnsFetchFailure({ error }));
        yield put(getReturnsGridFetch(undefined)); // Načtení gridu vratek
    }
}

// Watcher pro zpracování více vratek
export function* patchMultipleReturnsFetchWatch() {
    yield takeEvery('returnsUpdate/patchMultipleReturnsFetch', patchMultipleReturnsFetch);
}

const synchronizeReturnsDCIXFetchRequest = async (returns: ReturnType[]) => {
    const res = await api('post', `api/secure/dcix/import/returns`, { keys: returns.map((item) => item.ID) });
    return res.data;
};

function* synchronizeReturnsDCIXFetch(action: { type: string; payload: ReturnType[] }) {
    try {
        yield call((): any => synchronizeReturnsDCIXFetchRequest(action.payload));
        yield put(
            synchronizeReturnsDCIXFetchSuccess({
                messageSuccess: { title: translate('returns.message.synchronizeSuccessfull') }
            })
        );
        yield put(getReturnsGridFetch(undefined));
    } catch (error) {
        yield put(synchronizeReturnsDCIXFetchFailure({ error }));
        yield put(getReturnsGridFetch(undefined));
    }
}

export function* synchronizeReturnsDCIXFetchWatch() {
    yield takeEvery('returnsUpdate/synchronizeReturnsDCIXFetch', synchronizeReturnsDCIXFetch);
}
